import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AddEditViewVenueRatesComponent } from './add-edit-view-venue-rates/add-edit-view-venue-rates.component';
import { CommonModule, NgClass, LowerCasePipe} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { QuickSearchComponent } from 'app/Shared/Component/quick-search/quick-search.component';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Table, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Venue-Rates-columns.json';
import { VenueRatesService } from './venue-rates.service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { map } from 'rxjs';
import { asBlob, generateCsv } from 'export-to-csv';
import { HttpErrorResponse } from '@angular/common/http';
import { VenueRate } from './venue-rate.model';
import saveAs from 'file-saver';


@Component({
  selector: 'app-venue-rates',
  imports: [CommonModule, TableModule, ButtonModule, FormsModule,
        FilterPanelComponent, MatProgressSpinnerModule, NgClass, LowerCasePipe,
        MatTooltipModule, ConfirmDialogModule,ToastModule, QuickSearchComponent,AddEditViewVenueRatesComponent],
  templateUrl: './venue-rates.component.html',
  styleUrl: './venue-rates.component.scss'
})
export class VenueRatesComponent implements OnInit, OnDestroy{

    @ViewChild(('dt')) dt!: Table |any;
  quickFilterArray: any = GridColumnsJSON["Venue-Rate-Quick-Search-Fields"];
  gridColumns = GridColumnsJSON["Venue-Rate-Grid-Columns"];
  columns: any = [];
  public tbldatamsg = 'L o a d i n g . . . . .'; 
  emptytbldatamsg = "Data not found";
  subscription: any;
  selectedRow: any;
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  isExportToCSV = false;
  rowData: any = [];
  showDialog = false;
  dialogMode: any = 'add'
  selectedRowData: VenueRate = new VenueRate();

  constructor(public venueRatesService: VenueRatesService,
        public userService: UserService,
        private readonly gridService: GridService,
        private readonly emitterService: EmitterService,
        public constantService: ConstantService,
        private readonly messageService: MessageService,
        private readonly sortPipe: SortPipe,
        private readonly urlsService: UrlsService,
        private sharedHttpClientService: SharedHttpClientService,
        private confirmationService: ConfirmationService
  ) {}


  ngOnInit(): void {
    this.venueRatesService.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.venueRatesService.endLimit = this.venueRatesService.rowcount
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
    this.getColumns();
    this.venueRatesService.defaultFilter();
    this.getData();

  }

    getData() {
    this.venueRatesService.reloadData();
  }

  getColumns() {
    let column: any;
    column = this.gridColumns;
    this.columns = this.gridColumns.filter((col: any) => col.ui_columnname !== "Action");
    if (column !== null || column !== undefined) {
      this.gridColumns = this.gridService.getGridColumns(column);
    }
  }


    exportToCSV() {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });
    this.isExportToCSV = true;
    const filename = 'ODR_VenueRates_' + this.userService.getyyyyMMddDateFormate(new Date());
    let payload = {
      "mpid": this.userService.getActiveMPID(),
      "data": this.venueRatesService.defaultFilterArray,
      "startLimit": 0,
      "endLimit": this.venueRatesService.totalRecords
    }
    this.venueRatesService.getData(payload)
      .pipe(map((response: Response) => {
        return response;
      }))      
      .subscribe({
        next: (dataset: any) => {
          this.isExportToCSV = false;
            let data = dataset.Data;
            if (data.length > 0) {
              const options:any = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: filename,
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: filename
              };
              const csv = generateCsv(options)(this.constantService.getExportData(data, this.columns));
              const blob = asBlob(options)(csv);
              saveAs(blob, filename);
              this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.venueRatesService.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'No data found',
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.venueRatesService.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            }
        },
        error: (err: HttpErrorResponse) => {
          this.isExportToCSV = false;
        }
      });  
    }
  }

  onView(ri:any, selectedRow:any) {
    this.selectedRowData = selectedRow;
    this.dialogMode = 'view'
    this.showDialog = true;
    /* Catch User Action Log */
    this.userService.logUserActivity("View - ODR 606 Venue Rate", null, {
      'Text1': this.userService.userFirstName + ' Viewed ODR 606 Venue Rate',
      'Text2': 'User Filter Parameters: ' + JSON.stringify(selectedRow)
    });
  }

  onAdd() {
    this.selectedRowData = new VenueRate();
    this.selectedRowData.createdDate = this.userService.getDateTimeFormate(new Date());
    this.selectedRowData.updatedDate = this.userService.getDateTimeFormate(new Date());
    this.selectedRowData.createdUser = this.userService.getUserName();
    this.selectedRowData.updatedUser = this.userService.getUserName();

    this.dialogMode = 'add'
    this.showDialog = true;
    /* Catch User Action Log */
    this.userService.logUserActivity("Add - ODR 606 Venue Rate", null, {
      'Text1': this.userService.userFirstName + ' Added ODR 606 Venue Rate',
      'Text2': 'User Filter Parameters: ' + JSON.stringify(this.selectedRowData)
    });
  }

  onEdit(ri:any, selectedRow:any) {
    this.selectedRowData = selectedRow
    this.dialogMode = 'edit'
    this.showDialog = true;
    /* Catch User Action Log */
    this.userService.logUserActivity("Edit - ODR 606 Venue Rate", null, {
      'Text1': this.userService.userFirstName + ' Edited ODR 606 Venue Rate',
      'Text2': 'User Filter Parameters: ' + JSON.stringify(selectedRow)
    });
  }

  onDelete(ri:any, selectedRow:any) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"destination-details-confirm-dialog-button",
      rejectButtonStyleClass:"destination-details-confirm-dialog-button",
      accept: () => {
        this.venueRatesService.isLoadingResults = true;
        let payload = {
          "firmMPID": this.userService.getActiveMPID(),
          "id": selectedRow['id']
        }
        /* Catch User Action Log */
        this.userService.logUserActivity("Delete - ODR 606 Venue Rate", null, {
          'Text1': this.userService.userFirstName + ' Deleted ODR 606 Venue Rate',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(selectedRow)
        });
        this.venueRatesService.getDelete(payload)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (data: any) => {
              this.venueRatesService.isLoadingResults = false;
              if (data.status) {
                this.getData();
                this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted' });
                this.messageService.add({ severity: 'success', summary: 'Delete Record Message', detail: data.data });
              } else {
                this.messageService.add({ severity: 'error', summary: 'Delete Record Message', detail: data.data });
              }
            },    
            error: (err: HttpErrorResponse) => {
              this.venueRatesService.isLoadingResults = false;
              this.messageService.add({ severity: 'error', summary: 'Delete Record Message', detail: err.message });
            }
          });  
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'Action cancelled' });
      }
    });
  }

  changePage(event:any) {
    this.venueRatesService.startLimit = event.first;
    this.venueRatesService.rowcount = event.rows;
    this.venueRatesService.endLimit = this.venueRatesService.startLimit + this.venueRatesService.rowcount;
    if (this.venueRatesService.endLimit > this.venueRatesService.totalRecords) {
      this.venueRatesService.endLimit = this.venueRatesService.totalRecords;
    }
    this.getData();
  }


    FilterApplyFilterEvent(event:any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.venueRatesService.defaultFilterArray = [];
    this.venueRatesService.defaultFilterArray = event;
    this.venueRatesService.startLimit = 0;
    this.venueRatesService.endLimit = this.venueRatesService.rowcount
    this.getData();
  }

  sort(event:any) {
    if (event.multisortmeta[0].field != "") {
      if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
        this.sortClickCounter = this.sortClickCounter + 1;
      } else {
        this.sortClickCounter = 1;
      }
      if (this.sortClickCounter !== 3) {
        let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
        this.sortData.field = event.multisortmeta[0].field;
        this.sortData.order = sortOrder;
        this.venueRatesService.dataset = this.sortPipe.transform(this.venueRatesService.dataset, this.sortData.order, this.sortData.field);
      } else {
        this.resetSort();
      }
    }
  }
  resetSort() {
    this.dt.multiSortMeta[0].field = 'abc';
    this.dt.multiSortMeta[0].order = 0;
    this.venueRatesService.dataset = this.venueRatesService.defaultData;
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.venueRatesService.defaultFilterArray = $event;
    this.venueRatesService.startLimit = 0;
    this.venueRatesService.endLimit = this.venueRatesService.rowcount;
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.venueRatesService.defaultFilterArray = $event;
    this.venueRatesService.startLimit = 0;
    this.venueRatesService.endLimit = this.venueRatesService.rowcount;
    this.getData();
  }


  ngOnDestroy(): void {
      if (this.subscription)
        this.subscription.unsubscribe();
  }


}
